/* eslint-disable */
// <auto-generated>
// Generated by projects/template-ui/scripts/generate-contract-types.ts.
// Source: api/src/Riley.Jms.Application/Schemas/schema-manifest.json.
// </auto-generated>

export interface WorkflowReviewRequest {
  expectedETag: string;
  occurrenceId: number;
  workSummary: string;
}

export const WorkflowReviewRequestForm = {
  "contract": "WorkflowReviewRequest",
  "version": 1,
  "fields": [
    {
      "name": "workSummary",
      "type": "string",
      "control": "textarea",
      "label": "Work submitted for review",
      "labelToken": "workflow.review.workSummary",
      "required": true,
      "nullable": false,
      "minLength": 1,
      "maxLength": 4000,
      "errorCodes": [
        "workflow.review.work_required"
      ]
    }
  ]
} as const;
